export enum AppRoute {
    COURSES = "/courses",
    SCENARIO_COURSE = "/scenario_course",
    CASES = '/cases',
    GROUP_TESTING = '/group-testing'
}